// Espelha o enum EmployeeConsumptionPriceType do backend.
const EmployeeConsumptionPriceType = {
    NORMAL: 'NORMAL',
    COST: 'COST'
};

/** O produto tem preço de custo cadastrado? Custo zerado conta como não cadastrado. */
export const hasCostPrice = (product) => Number(product?.costPrice || 0) > 0;

/**
 * Tipo de preço com que um item do lançamento é cobrado.
 *
 * No lançamento pelo custo, o produto sem custo cadastrado vai pelo preço normal e os demais
 * seguem pelo custo. Antes um único produto sem custo jogava o lançamento inteiro para o preço
 * normal, mesmo com "Preço de custo" escolhido. Regra única da prévia na tela e do envio, para
 * o valor salvo ser o mesmo que o operador conferiu.
 *
 * @param {string} launchPriceType - Tipo de preço escolhido para o lançamento.
 * @param {object} product - Produto do item, com costPrice.
 */
export const resolveItemPriceType = (launchPriceType, product) => (
    launchPriceType === EmployeeConsumptionPriceType.COST && hasCostPrice(product)
        ? EmployeeConsumptionPriceType.COST
        : EmployeeConsumptionPriceType.NORMAL
);

export default EmployeeConsumptionPriceType;
